import { ProductDto } from '@eurogast/hub-client-typescript';
import ProductService from '@/services/product/ProductService';
import ProductApiWrapper from '@/services/product/ProductApiWrapper';

export default class FairProductService implements ProductService {
  private fairCode: string;

  private api = ProductApiWrapper.singleton();

  constructor(fairCode: string) {
    this.fairCode = fairCode;
  }

  public getProductBySkuBatch(
    skus: string[],
    showInactive?: boolean
  ): Promise<ProductDto[]> {
    return this.api.getProductBySkuBatch(
      skus,
      showInactive,
      this.fairCode
    );
  }


}
